import { swiperRegister, Swiper } from "@ml/swiper/swiper";
import SwiperCore from "swiper/bundle";

swiperRegister();




/* ===============================================
# // トップページ
=============================================== */

const conceptSlide = new SwiperCore('.swiper.p-concept__box-slide', {
    slidesPerView: 1.5,
    spaceBetween: 10,
    loop: true,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    breakpoints: {
      // 768px以上の場合
      768: {
        slidesPerView: 1.75,
        spaceBetween: 20,
      },
      // 1024px以上の場合
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
      }
    }
  });
  

// const swiperType1 = Swiper({
//     el: "sp-concept__box-slide",
//     options: {
//         slidesPerView: 1.5,
//         spaceBetween: 24,
//         centeredSlides: true,
//         speed: 500,
//         loop: true,
//         pagination: {
//             clickable: true,
//         },
//         breakpoints: {
//             768: {
//                 slidesPerView: 2.5,
//             },
//         },

//     },
// });
